import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide eye toggle. Pass any props you would pass to <Input />.
 * The wrapper is full-width and positions the toggle button inside on the right.
 */
export default function PasswordInput({ "data-testid": testid, className = "", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={show ? "text" : "password"}
        className={`pr-11 ${className}`}
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
        title={show ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-[#525252] hover:text-[#0A0A0A] focus:outline-none focus:text-[#2596be]"
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
